<template>
  <div class="cron-expression">
    <h1>Cron 表达式生成与测试工具</h1>
    
    <div class="cron-container">
      <!-- 表达式生成器 -->
      <div class="generator-section">
        <h3>表达式生成器</h3>
        
        <el-tabs v-model="activeTab">
          <!-- 秒 -->
          <el-tab-pane label="秒" name="second">
            <div class="field-options">
              <el-radio-group v-model="second.type" @change="generateExpression">
                <el-radio label="every">每秒</el-radio>
                <el-radio label="interval">周期</el-radio>
                <el-radio label="specific">指定</el-radio>
              </el-radio-group>
              
              <template v-if="second.type === 'interval'">
                <span>从</span>
                <el-input-number
                  v-model="second.start"
                  :min="0"
                  :max="59"
                  @change="generateExpression"
                />
                <span>到</span>
                <el-input-number
                  v-model="second.end"
                  :min="0"
                  :max="59"
                  @change="generateExpression"
                />
              </template>
              
              <template v-if="second.type === 'specific'">
                <el-select
                  v-model="second.specific"
                  multiple
                  placeholder="选择秒"
                  @change="generateExpression"
                >
                  <el-option
                    v-for="i in 60"
                    :key="i-1"
                    :label="i-1"
                    :value="i-1"
                  />
                </el-select>
              </template>
            </div>
          </el-tab-pane>

          <!-- 分钟 -->
          <el-tab-pane label="分" name="minute">
            <div class="field-options">
              <el-radio-group v-model="minute.type" @change="generateExpression">
                <el-radio label="every">每分</el-radio>
                <el-radio label="interval">周期</el-radio>
                <el-radio label="specific">指定</el-radio>
              </el-radio-group>
              
              <template v-if="minute.type === 'interval'">
                <span>从</span>
                <el-input-number
                  v-model="minute.start"
                  :min="0"
                  :max="59"
                  @change="generateExpression"
                />
                <span>到</span>
                <el-input-number
                  v-model="minute.end"
                  :min="0"
                  :max="59"
                  @change="generateExpression"
                />
              </template>
              
              <template v-if="minute.type === 'specific'">
                <el-select
                  v-model="minute.specific"
                  multiple
                  placeholder="选择分钟"
                  @change="generateExpression"
                >
                  <el-option
                    v-for="i in 60"
                    :key="i-1"
                    :label="i-1"
                    :value="i-1"
                  />
                </el-select>
              </template>
            </div>
          </el-tab-pane>

          <!-- 小时 -->
          <el-tab-pane label="时" name="hour">
            <div class="field-options">
              <el-radio-group v-model="hour.type" @change="generateExpression">
                <el-radio label="every">每时</el-radio>
                <el-radio label="interval">周期</el-radio>
                <el-radio label="specific">指定</el-radio>
              </el-radio-group>
              
              <template v-if="hour.type === 'interval'">
                <span>从</span>
                <el-input-number
                  v-model="hour.start"
                  :min="0"
                  :max="23"
                  @change="generateExpression"
                />
                <span>到</span>
                <el-input-number
                  v-model="hour.end"
                  :min="0"
                  :max="23"
                  @change="generateExpression"
                />
              </template>
              
              <template v-if="hour.type === 'specific'">
                <el-select
                  v-model="hour.specific"
                  multiple
                  placeholder="选择小时"
                  @change="generateExpression"
                >
                  <el-option
                    v-for="i in 24"
                    :key="i-1"
                    :label="i-1"
                    :value="i-1"
                  />
                </el-select>
              </template>
            </div>
          </el-tab-pane>

          <!-- 日 -->
          <el-tab-pane label="日" name="day">
            <div class="field-options">
              <el-radio-group v-model="day.type" @change="generateExpression">
                <el-radio label="every">每日</el-radio>
                <el-radio label="interval">周期</el-radio>
                <el-radio label="specific">指定</el-radio>
                <el-radio label="lastDay">最后一天</el-radio>
                <el-radio label="workDay">工作日</el-radio>
              </el-radio-group>
              
              <template v-if="day.type === 'interval'">
                <span>从</span>
                <el-input-number
                  v-model="day.start"
                  :min="1"
                  :max="31"
                  @change="generateExpression"
                />
                <span>到</span>
                <el-input-number
                  v-model="day.end"
                  :min="1"
                  :max="31"
                  @change="generateExpression"
                />
              </template>
              
              <template v-if="day.type === 'specific'">
                <el-select
                  v-model="day.specific"
                  multiple
                  placeholder="选择日期"
                  @change="generateExpression"
                >
                  <el-option
                    v-for="i in 31"
                    :key="i"
                    :label="i"
                    :value="i"
                  />
                </el-select>
              </template>
            </div>
          </el-tab-pane>

          <!-- 月 -->
          <el-tab-pane label="月" name="month">
            <div class="field-options">
              <el-radio-group v-model="month.type" @change="generateExpression">
                <el-radio label="every">每月</el-radio>
                <el-radio label="interval">周期</el-radio>
                <el-radio label="specific">指定</el-radio>
              </el-radio-group>
              
              <template v-if="month.type === 'interval'">
                <span>从</span>
                <el-input-number
                  v-model="month.start"
                  :min="1"
                  :max="12"
                  @change="generateExpression"
                />
                <span>到</span>
                <el-input-number
                  v-model="month.end"
                  :min="1"
                  :max="12"
                  @change="generateExpression"
                />
              </template>
              
              <template v-if="month.type === 'specific'">
                <el-select
                  v-model="month.specific"
                  multiple
                  placeholder="选择月份"
                  @change="generateExpression"
                >
                  <el-option
                    v-for="i in 12"
                    :key="i"
                    :label="i"
                    :value="i"
                  />
                </el-select>
              </template>
            </div>
          </el-tab-pane>

          <!-- 周 -->
          <el-tab-pane label="周" name="week">
            <div class="field-options">
              <el-radio-group v-model="week.type" @change="generateExpression">
                <el-radio label="every">每周</el-radio>
                <el-radio label="interval">周期</el-radio>
                <el-radio label="specific">指定</el-radio>
                <el-radio label="lastWeek">最后一周</el-radio>
              </el-radio-group>
              
              <template v-if="week.type === 'interval'">
                <span>从</span>
                <el-select
                  v-model="week.start"
                  placeholder="选择开始星期"
                  @change="generateExpression"
                >
                  <el-option
                    v-for="(day, index) in weekDays"
                    :key="index"
                    :label="day"
                    :value="index"
                  />
                </el-select>
                <span>到</span>
                <el-select
                  v-model="week.end"
                  placeholder="选择结束星期"
                  @change="generateExpression"
                >
                  <el-option
                    v-for="(day, index) in weekDays"
                    :key="index"
                    :label="day"
                    :value="index"
                  />
                </el-select>
              </template>
              
              <template v-if="week.type === 'specific'">
                <el-select
                  v-model="week.specific"
                  multiple
                  placeholder="选择星期"
                  @change="generateExpression"
                >
                  <el-option
                    v-for="(day, index) in weekDays"
                    :key="index"
                    :label="day"
                    :value="index"
                  />
                </el-select>
              </template>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <!-- 表达式结果 -->
      <div class="expression-section">
        <div class="expression-result">
          <el-input
            v-model="cronExpression"
            placeholder="Cron 表达式"
            :readonly="true"
          >
            <template #append>
              <el-button @click="copyExpression">复制</el-button>
            </template>
          </el-input>
        </div>

        <div class="expression-preview">
          <h4>最近10次执行时间</h4>
          <ul class="preview-list">
            <li v-for="(time, index) in nextExecutions" :key="index">
              {{ time }}
            </li>
          </ul>
        </div>
      </div>

      <!-- 常用示例 -->
      <div class="examples-section">
        <h3>常用示例</h3>
        <el-table :data="commonExamples" style="width: 100%">
          <el-table-column prop="expression" label="表达式" width="200" />
          <el-table-column prop="description" label="说明" />
          <el-table-column label="操作" width="100">
            <template #default="scope">
              <el-button
                link
                type="primary"
                @click="useExample(scope.row.expression)"
              >
                使用
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 说明区域 -->
      <div class="info-section">
        <h3>Cron 表达式说明</h3>
        <p>Cron 表达式由6个或7个字段组成，从左到右依次为：</p>
        <ul>
          <li>秒：0-59</li>
          <li>分：0-59</li>
          <li>时：0-23</li>
          <li>日：1-31</li>
          <li>月：1-12</li>
          <li>周：0-7（0和7都表示周日）</li>
          <li>年：可选，1970-2099</li>
        </ul>
        <p>特殊字符说明：</p>
        <ul>
          <li>* 表示任意值</li>
          <li>, 用于列举值</li>
          <li>- 表示范围</li>
          <li>/ 表示起始时间开始触发，每隔固定时间触发一次</li>
          <li>? 表示不指定值，仅日期和星期使用</li>
          <li>L 表示最后，仅日期和星期使用</li>
          <li>W 表示工作日，仅日期使用</li>
          <li># 用于确定每月第几个星期几，仅星期使用</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import cronstrue from 'cronstrue'
import 'cronstrue/locales/zh_CN'
import parser from 'cron-parser'

const activeTab = ref('second')
const cronExpression = ref('* * * * * ?')
const nextExecutions = ref([])

// 星期名称
const weekDays = [
  '周日', '周一', '周二', '周三', '周四', '周五', '周六'
]

// 字段配置
const second = reactive({
  type: 'every',
  start: 0,
  end: 59,
  specific: []
})

const minute = reactive({
  type: 'every',
  start: 0,
  end: 59,
  specific: []
})

const hour = reactive({
  type: 'every',
  start: 0,
  end: 23,
  specific: []
})

const day = reactive({
  type: 'every',
  start: 1,
  end: 31,
  specific: []
})

const month = reactive({
  type: 'every',
  start: 1,
  end: 12,
  specific: []
})

const week = reactive({
  type: 'every',
  start: 1,
  end: 5,
  specific: []
})

// 常用示例
const commonExamples = [
  { expression: '0 0 * * * ?', description: '每小时整点触发' },
  { expression: '0 0 0 * * ?', description: '每天零点触发' },
  { expression: '0 0 12 * * ?', description: '每天中午12点触发' },
  { expression: '0 0/30 * * * ?', description: '每半小时触发' },
  { expression: '0 0 0 ? * MON', description: '每周一零点触发' },
  { expression: '0 0 0 1 * ?', description: '每月1号零点触发' },
  { expression: '0 0 0 L * ?', description: '每月最后一天零点触发' },
  { expression: '0 0 0 ? * MON-FRI', description: '每个工作日零点触发' }
]

// 生成表达式
const generateExpression = () => {
  let expr = []

  // 秒
  expr.push(getFieldExpression(second))
  // 分
  expr.push(getFieldExpression(minute))
  // 时
  expr.push(getFieldExpression(hour))
  // 日
  expr.push(getDayExpression())
  // 月
  expr.push(getFieldExpression(month))
  // 周
  expr.push(getWeekExpression())

  cronExpression.value = expr.join(' ')
  updateNextExecutions()
}

// 获取字段表达式
const getFieldExpression = (field) => {
  switch (field.type) {
    case 'every':
      return '*'
    case 'interval':
      return `${field.start}-${field.end}`
    case 'specific':
      return field.specific.sort((a, b) => a - b).join(',')
    default:
      return '*'
  }
}

// 获取日期表达式
const getDayExpression = () => {
  switch (day.type) {
    case 'every':
      return '*'
    case 'interval':
      return `${day.start}-${day.end}`
    case 'specific':
      return day.specific.sort((a, b) => a - b).join(',')
    case 'lastDay':
      return 'L'
    case 'workDay':
      return 'W'
    default:
      return '*'
  }
}

// 获取星期表达式
const getWeekExpression = () => {
  switch (week.type) {
    case 'every':
      return '?'
    case 'interval':
      return `${week.start}-${week.end}`
    case 'specific':
      return week.specific.sort((a, b) => a - b).join(',')
    case 'lastWeek':
      return 'L'
    default:
      return '?'
  }
}

// 更新下次执行时间
const updateNextExecutions = () => {
  try {
    const interval = parser.parseExpression(cronExpression.value)
    nextExecutions.value = []
    for (let i = 0; i < 10; i++) {
      const nextTime = interval.next()
      const formattedTime = nextTime.toISOString().replace('T', ' ').substring(0, 19)
      nextExecutions.value.push(formattedTime)
    }
  } catch (err) {
    nextExecutions.value = ['表达式解析错误']
  }
}

// 复制表达式
const copyExpression = async () => {
  try {
    await navigator.clipboard.writeText(cronExpression.value)
    ElMessage.success('复制成功')
  } catch (error) {
    ElMessage.error('复制失败')
  }
}

// 使用示例
const useExample = (expression) => {
  cronExpression.value = expression
  updateNextExecutions()
}

// 初始化
generateExpression()

// 解析 cron 表达式
const parseCronExpression = (expression) => {
  try {
    return cronstrue.toString(expression, { locale: 'zh_CN' })
  } catch (e) {
    return '无效的 Cron 表达式'
  }
}
</script>

<style scoped>
.cron-expression {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  margin-top: 80px;
}

.cron-container {
  margin-top: 20px;
}

.generator-section {
  margin: 20px 0;
  padding: 20px;
  background-color: #f5f7fa;
  border-radius: 8px;
}

.field-options {
  margin: 15px 0;
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.expression-section {
  margin: 20px 0;
}

.expression-result {
  margin-bottom: 20px;
}

.expression-preview {
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 8px;
}

.preview-list {
  list-style: none;
  padding: 0;
  margin: 10px 0;
}

.preview-list li {
  padding: 5px 0;
  border-bottom: 1px solid #ebeef5;
}

.preview-list li:last-child {
  border-bottom: none;
}

.examples-section {
  margin: 20px 0;
}

.info-section {
  margin-top: 30px;
  padding: 20px;
  background-color: #f5f7fa;
  border-radius: 8px;
}

.info-section ul {
  padding-left: 20px;
  margin: 10px 0;
}

.info-section li {
  margin: 8px 0;
  line-height: 1.5;
}

@media (max-width: 768px) {
  .field-options {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style> 